<template>
    <div class="rzy-page">
        <div class="rzy-top-bar">
            <el-tag style="height: 40px;line-height: 40px;margin-right: 1%;">{{this.$route.query.Name}}</el-tag>
            <el-button type="primary" @click="Print" icon="el-icon-printer">打印</el-button>
        </div>

        <div v-if="optionsvalue == 1" id="localListTableId_client">
            <el-table :data="responseData" :header-cell-style="{'text-align':'center'}" :cell-style="{'padding':'0px'}"
                border stripe show-summary :summary-method="getSummaries">

                <el-table-column sortable prop="createTime" label="出货日期" align="center">
                </el-table-column>
				<el-table-column prop="shipOrderNumber" label="出货单号" align="center">
					<template slot-scope="scope">
					    <el-link type="primary" @click="gotoShipmentDetails(scope.row.shipOrderId)">{{scope.row.shipOrderNumber}}</el-link>
					</template>
				</el-table-column>
				<el-table-column prop="operator" label="操作员" align="center">
				</el-table-column>
				<el-table-column prop="materialName" label="物料名称" align="center">
				</el-table-column>
				<el-table-column prop="materialNumber" label="物料编号" align="center">
				</el-table-column>
                <el-table-column prop="customer" label="客户名称" align="center">
                </el-table-column>
                <el-table-column prop="productWeight" label="出货重量(千克)" align="center">
                </el-table-column>
                <el-table-column prop="productLength" label="出货米数(米)" align="center">
                </el-table-column>
                <el-table-column prop="juanbuCount" label="出货匹数" align="center">
                </el-table-column>

            </el-table>
        </div>
		
		<div v-if="optionsvalue == 0" id="localListTableId_material">
		    <el-table :data="responseData" :header-cell-style="{'text-align':'center'}" :cell-style="{'padding':'0px'}"
		        border stripe show-summary :summary-method="getSummaries">
		
		        <el-table-column sortable prop="createTime" label="出货日期" align="center">
		        </el-table-column>
				<el-table-column prop="shipOrderNumber" label="出货单号" align="center">
					<template slot-scope="scope">
					    <el-link type="primary" @click="gotoShipmentDetails(scope.row.shipOrderId)">{{scope.row.shipOrderNumber}}</el-link>
					</template>
				</el-table-column>
				<el-table-column prop="operator" label="出货员" align="center">
				</el-table-column>
				<el-table-column prop="customer" label="客户名称" align="center">
				</el-table-column>
				<el-table-column prop="materialName" label="物料名称" align="center">
				</el-table-column>
				<el-table-column prop="materialNumber" label="物料编号" align="center">
				</el-table-column>
		        <el-table-column prop="productWeight" label="出货重量(千克)" align="center">
		        </el-table-column>
		        <el-table-column prop="productLength" label="出货米数(米)" align="center">
		        </el-table-column>
		        <el-table-column prop="juanbuCount" label="出货匹数" align="center">
		        </el-table-column>
		
		    </el-table>
		</div>
    </div>
</template>

<script>
    import printJS from 'print-js'
    export default {
        data() {
            return {
                //分页 -- sta
                pageInfo: this.$route.query.PageInfo,
                responseData: [
                    // 调试用假数据--正式版注释掉
                    // {
                    //     shipmentTime: '2023-01-31',
                    //     client: 'K1',
                    //     operator: 'XXX',
                    //     materialName: 'W1',
                    //     materialNumber: '123456',
                    //     shipmentWeight: '1000',
                    //     shipmentMeter: '100',
                    //     shipmentNumber: '10',
                    //     opration: '详情',
                    // },
                ],
                optionsvalue: Number(this.$route.query.Type)
            }
        },
        mounted() {
			this.pageInfo = JSON.parse(sessionStorage.getItem("DetailMorePageInfo"))
            this.getList(this.pageInfo)
        },
        methods: {
            // 获取XX分页列表
            getList(val) {
                this.$requestBase({
                    url: 'v1/ship/list',
                    method: 'get',
                    params: val
                }).then(res => {
                    this.responseData = this.formatResponse(res.data.list)
                })
            },
            formatResponse(response) {
				let res = []
				response.forEach((item,index) => {
					let i =0
					for(;i<res.length;i++){
						if(res[i].shipOrderNumber == item.shipOrderNumber){
							res[i].productWeight = Number(res[i].productWeight)+Number(item.productWeight)
							res[i].productLength = Number(res[i].productLength)+Number(item.productLength)
							res[i].juanbuCount = Number(res[i].juanbuCount)+Number(item.juanbuCount)
							return
						}
					}
					res.push(item)
				})
				res.forEach((item,index) => {
					item.createTime = this.utils.timestampToTime(item.createTime, 2)
					item.productLength = (Number(item.productLength)/100).toFixed(2)
					item.productWeight = (Number(item.productWeight)/1000).toFixed(2)
				})
				return res
            },

            gotoShipmentDetails(id) {
				this.$router.push(`shipmentOrderDetalis/${id}`)
            },
            filterClient(value, row) {
                return row.client === value
            },
            filterMaterial(value, row) {
                return row.materialName === value
            },
            // 日期范围选择控件，内容改变事件
            daterangeSelectChange() {

                //    //开始时间 转 时间戳
                //    let m_date = new Date(this.daterangeSelectResult[0]);
                //    let m_time = Date.parse(m_date); //精确到秒,毫秒会用000替代
                //    this.pageInfo.startTime = m_time

                //    //结束时间 转 时间戳
                //    m_date = new Date(this.daterangeSelectResult[1]);
                //    m_time = Date.parse(m_date); //精确到秒,毫秒会用000替代
                //    this.pageInfo.endTime = m_time

                //    this.refreshPage()
            },
			Print() {
				switch(this.optionsvalue){
					case 0:
						this.initPrint('localListTableId_material')
						break
					case 1:
						this.initPrint('localListTableId_client')
						break
				}
			},
            // 在打印当前报表前，拼接title
            initPrint(id) {
                printJS({
                    // printable: 'pageDetail', type: 'html', targetStyles: ['*'], maxWidth: 1100, scanStyles: true
                    printable: id,
                    type: 'html',
                    targetStyles: ['*'],
                    maxWidth: 1100,
                    scanStyles: true,
                    header: '出货报表',
                    // style: `@page {size:auto;margin-top:100px; margin-left:15px; margin-right: 15px;}
                    //  thead th {
                    //    border-top: 2px solid #000;
                    //    border-right: 2px solid #000;
                    //    border-left: 2px solid #000;
                    //  }
                    //  tbody td {
                    //    border: 2px solid #000;
                    //  }
                    //  tbody {
                    //    text-align: center;
                    //  }
                    //  table {
                    //    border-collapse: collapse;
                    //  }`,					
                })
            },
            getSummaries(param) {
                const {
                    columns,
                    data
                } = param;
                const sums = [];
                columns.forEach((column, index) => {
                    if (index === 0) {
                        sums[index] = '汇总';
                        return;
                    }
                    const values = data.map(item => Number(item[column.property]));
                    if (!values.every(value => isNaN(value))) {
                        sums[index] = values.reduce((prev, curr) => {
                            const value = Number(curr);
                            if (!isNaN(value)) {
                                return prev + curr;
                            } else {
                                return prev;
                            }
                        }, 0);
                        switch (index) {
                            case 6:
								sums[index] = sums[index].toFixed(2)
                                sums[index] += ' 千克';
                                break;
                            case 7:
								sums[index] = sums[index].toFixed(2)
                                sums[index] += ' 米';
                                break;
                            case 8:
                                sums[index] += ' 匹';
                                break;
							default:
								sums[index] = '';
								break;
                        }
                    } else {
                        sums[index] = '';
                    }
                });
                return sums;
            },
        }
    }
</script>

<style>
</style>
